























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { CollegesService } from "@/zh-website/src/views/Colleges/service";
@Component({
  components: {}
})
export default class Teminations extends Vue {
  flag = 0;
  rules = {
    Idcard: [
      {
        required: true,
        message: "必填字段",
        trigger: "blur"
      }
    ],
    name: [
      {
        required: true,
        message: "必填字段",
        trigger: "blur"
      }
    ]
  };
  ruleForm = {
    name: "",
    Idcard: ""
  };

  search() {
    (this.$refs.ruleForm as any).validate(valid => {
      if (valid) {
        //请求接口
        const params = {
          realName: this.ruleForm.name,
          idCard: this.ruleForm.Idcard
        };
        CollegesService.checkEmployeeDelisting(params).then(res => {
          if (res) {
            this.flag = 2;
          } else {
            this.flag = 1;
          }
        });
      } else {
        return false;
      }
    });
  }
  isObjectValueEqual(a, b) {
    //取对象a和b的属性名
    const aProps = Object.getOwnPropertyNames(a);
    const bProps = Object.getOwnPropertyNames(b);
    //判断属性名的length是否一致
    if (aProps.length != bProps.length) {
      return false;
    }
    //循环取出属性名，再判断属性值是否一致
    for (let i = 0; i < aProps.length; i++) {
      const propName = aProps[i];
      if (a[propName] !== b[propName]) {
        return false;
      }
    }
    return true;
  }
}
